export type CoachApplicationStatus =
  | "PENDING"
  | "ACCEPTED"
  | "REJECTED"
  | "REVIEW"
  | "RESUBMITTED";

export type CoachGender = "MALE" | "FEMALE";
export type CoachClothingSize = "S" | "M" | "L" | "XL" | "XXL";

export type CoachFileKey =
  | "photo"
  | "medicalCertificate"
  | "noConvictionProof"
  | "oldLicense"
  | "diplomaCopy";

export type CoachFileUrlKey = `${CoachFileKey}Url`;

export const COACH_FILE_URL_KEYS: Record<CoachFileKey, CoachFileUrlKey> = {
  photo: "photoUrl",
  medicalCertificate: "medicalCertificateUrl",
  noConvictionProof: "noConvictionProofUrl",
  oldLicense: "oldLicenseUrl",
  diplomaCopy: "diplomaCopyUrl",
};

export const REQUIRED_COACH_FILE_KEYS: CoachFileKey[] = [
  "photo",
  "medicalCertificate",
  "noConvictionProof",
  "diplomaCopy",
];

export interface CoachPersonalInfo {
  name: string;
  fathersName?: string;
  surname: string;
  placeOfBirth?: string;
  residence?: string;
  dateOfBirth?: string;
  gender?: CoachGender;
  nationality?: string;
  personalNumber?: string;
  address?: string;
}

export interface CoachProfessionalInfo {
  clothingSize?: CoachClothingSize;
  languageSkills?: string;
  careerAsPlayer?: string;
  careerAsCoach?: string;
  otherExperience?: string;
  phoneNumber?: string;
  email: string;
}

export interface CoachApplicationReviewResponse {
  id: string;
  courseId: string;
  courseName: string;
  name: string;
  fathersName: string;
  surname: string;
  placeOfBirth: string;
  residence: string;
  dateOfBirth: string;
  gender: CoachGender;
  clothingSize: CoachClothingSize;
  nationality: string;
  personalNumber: string;
  address: string;
  careerAsPlayer: string;
  careerAsCoach: string;
  otherExperience: string;
  languageSkills: string;
  phoneNumber: string;
  email: string;
  photoUrl: string | null;
  medicalCertificateUrl: string | null;
  noConvictionProofUrl: string | null;
  oldLicenseUrl: string | null;
  diplomaCopyUrl: string | null;
  status: CoachApplicationStatus;
  adminComment: string;
}

export interface CoachApplicationReviewRequest {
  courseId: string;
  name: string;
  fathersName?: string;
  surname: string;
  placeOfBirth?: string;
  residence?: string;
  dateOfBirth?: string;
  gender?: CoachGender;
  clothingSize?: CoachClothingSize;
  nationality?: string;
  personalNumber?: string;
  address?: string;
  careerAsPlayer?: string;
  careerAsCoach?: string;
  otherExperience?: string;
  languageSkills?: string;
  phoneNumber?: string;
  email: string;
}

export interface ApiErrorBody {
  status: number;
  message: string;
  timestamp: string;
}
